<template>
    <b-form-input
        ref="comments"
        :key="key"
        v-model="form.comments"
        size="sm"
        :class="reactiveClass"
        @change="saveComments"
    >
    </b-form-input>
</template>

<script>
import TableFormHandler from '../../../common/mixins/TableFormHandler'

export default {
    name: 'CommentsForm',

    mixins: [TableFormHandler],

    props: {
        entry: {},
    },

    created() {
        this.align = 'left'
    },

    methods: {
        initForm() {
            this.form.comments = this.entry.comments
        },

        setInitialKey() {
            this.key = `comments${this.entry.id}`
        },

        unFocus() {
            this.$refs.comments.blur()
        },

        async saveComments() {
            try {
                await axios.put(
                    `/time-sheets/${this.entry.id}/comments`,
                    this.form
                )
                this.handleSuccess()
            } catch (error) {
                console.log(error)
                this.handleError()
            }
        },
    },
}
</script>

<style scoped></style>
